import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dark-version" }
const _hoisted_2 = {
  id: "switch",
  class: "switch"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        type: "checkbox",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDarkMode && _ctx.toggleDarkMode(...args))),
        id: "slider"
      }),
      _hoisted_3
    ])
  ]))
}